import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  GetTestCasesReportingResponse,
  GraphQlQuery
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GraphQlQuery
  onSuccess?: (data: GetTestCasesReportingResponse) => void
  children?: (data: GetTestCasesReportingResponse) => ReactElement | boolean
}

const GetAiReportingRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/reporting`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiReportingRequest
